import Hero from "@/components/Hero";
import CostMeter from "@/components/CostMeter";
import AnimatedStats from "@/components/AnimatedStats";
import TrustedBy from "@/components/TrustedBy";
import Mission from "@/components/Mission";
import IdeaBlocks from "@/components/IdeaBlocks";
import OfferStrip from "@/components/OfferStrip";
import Capabilities from "@/components/Capabilities";
import Team from "@/components/Team";
import ROICalculator from "@/components/ROICalculator";
import Work from "@/components/Work";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";

export default function HomePage() {
    return (
        <main className="bg-white text-[#0a0a0b]">
            <Hero />
            <CostMeter />
            <AnimatedStats />
            <TrustedBy />
            <Mission />
            <IdeaBlocks />
            <OfferStrip />
            <Capabilities />
            <Team />
            <ROICalculator />
            <HowItWorks />
            <Work />
            <FAQ />
            <Contact />
        </main>
    );
}
